// v3.3.718 — سجل زوار المكتب: كشف بالزوار (اسم، جوال، صنف، خيارات فرعية، ملاحظات)
// إدارة الأصناف والخيارات من الإعدادات ← تبويب "زوار المكتب"
import React, { useState, useEffect, useCallback } from "react";
import { officeVisitors } from "../services/api";
import { FiPlus, FiEdit2, FiTrash2, FiRefreshCw, FiPrinter, FiSearch, FiX } from "react-icons/fi";

const inputStyle = {
  width: "100%", padding: "9px 12px", border: "1px solid #cbd5e1", borderRadius: 8,
  fontSize: 13, fontFamily: "inherit", boxSizing: "border-box", background: "#fff",
};
const btnStyle = (bg, color = "#fff") => ({
  padding: "9px 16px", background: bg, color, border: "none", borderRadius: 8,
  fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit",
  display: "inline-flex", alignItems: "center", gap: 6,
});

const TYPE_COLORS = {
  "عميل حالي": "#059669", "عميل محتمل": "#f59e0b", "عميل جاد": "#dc2626",
  "مسوق": "#7c3aed", "مورد": "#0891b2", "مقاول": "#92400e",
};
const typeColor = (name) => TYPE_COLORS[name] || "#475569";

const fmtDate = (d) => {
  if (!d) return "—";
  const dt = new Date(d);
  return dt.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }) +
    " " + dt.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
};

// نموذج إضافة/تعديل زائر
function VisitorForm({ types, initial, onSave, onClose }) {
  const [name, setName]       = useState(initial?.name || "");
  const [phone, setPhone]     = useState(initial?.phone || "");
  const [typeId, setTypeId]   = useState(initial?.type_id || "");
  const [options, setOptions] = useState(Array.isArray(initial?.options) ? initial.options : []);
  const [notes, setNotes]     = useState(initial?.notes || "");
  const [saving, setSaving]   = useState(false);
  const [err, setErr]         = useState("");
  // v3.3.920 — مرفقات: ملفات جديدة للرفع + الملفات المحفوظة (عند التعديل)
  const [newFiles, setNewFiles] = useState([]);
  const [savedFiles, setSavedFiles] = useState(Array.isArray(initial?.files) ? initial.files : []);
  const fmtSize = (b) => b > 1024 * 1024 ? (b / 1024 / 1024).toFixed(1) + " MB" : Math.max(1, Math.round((b || 0) / 1024)) + " KB";

  const selectedType = types.find(t => String(t.id) === String(typeId));

  const toggleOption = (label) => {
    setOptions(prev => prev.includes(label) ? prev.filter(o => o !== label) : [...prev, label]);
  };

  const save = async () => {
    if (!name.trim()) { setErr("اسم الزائر مطلوب"); return; }
    setSaving(true); setErr("");
    try {
      await onSave({ name: name.trim(), phone: phone.trim(), type_id: typeId || null, options, notes: notes.trim() }, newFiles);
      onClose();
    } catch (e) {
      setErr(e.response?.data?.error || "فشل الحفظ");
    } finally { setSaving(false); }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.45)", zIndex: 1200,
      display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }} onClick={onClose}>
      <div dir="rtl" onClick={e => e.stopPropagation()} style={{
        background: "#fff", borderRadius: 14, width: "min(560px, 96vw)", maxHeight: "92vh",
        overflowY: "auto", padding: 22, boxShadow: "0 20px 50px rgba(0,0,0,0.25)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#1e293b" }}>
            {initial ? "✏️ تعديل زائر" : "🚪 تسجيل زائر جديد"}
          </h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#64748b" }}><FiX size={18} /></button>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: "#475569", display: "block", marginBottom: 4 }}>الاسم *</label>
            <input style={inputStyle} value={name} onChange={e => setName(e.target.value)} placeholder="اسم الزائر" />
          </div>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: "#475569", display: "block", marginBottom: 4 }}>رقم الهاتف</label>
            <input style={{ ...inputStyle, direction: "ltr", textAlign: "right" }} value={phone} onChange={e => setPhone(e.target.value)} placeholder="05xxxxxxxx" />
          </div>
        </div>

        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: "#475569", display: "block", marginBottom: 6 }}>صنف الزائر</label>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {types.map(t => (
              <button key={t.id} onClick={() => { setTypeId(String(t.id) === String(typeId) ? "" : t.id); setOptions([]); }}
                style={{
                  padding: "7px 14px", borderRadius: 20, fontSize: 12.5, fontWeight: 600, cursor: "pointer", fontFamily: "inherit",
                  border: `1.5px solid ${typeColor(t.name)}`,
                  background: String(t.id) === String(typeId) ? typeColor(t.name) : "#fff",
                  color: String(t.id) === String(typeId) ? "#fff" : typeColor(t.name),
                }}>
                {t.name}
              </button>
            ))}
          </div>
        </div>

        {selectedType && selectedType.options.length > 0 && (
          <div style={{ marginBottom: 12, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, padding: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#475569", marginBottom: 8 }}>
              خيارات «{selectedType.name}» (اختر ما ينطبق):
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {selectedType.options.map(o => (
                <label key={o.id} style={{
                  display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 12px",
                  borderRadius: 8, fontSize: 12.5, cursor: "pointer",
                  border: `1px solid ${options.includes(o.label) ? typeColor(selectedType.name) : "#cbd5e1"}`,
                  background: options.includes(o.label) ? `${typeColor(selectedType.name)}15` : "#fff",
                  color: options.includes(o.label) ? typeColor(selectedType.name) : "#475569",
                  fontWeight: options.includes(o.label) ? 700 : 400,
                }}>
                  <input type="checkbox" checked={options.includes(o.label)} onChange={() => toggleOption(o.label)} style={{ accentColor: typeColor(selectedType.name) }} />
                  {o.label}
                </label>
              ))}
            </div>
          </div>
        )}
        {selectedType && selectedType.options.length === 0 && (
          <div style={{ marginBottom: 12, fontSize: 11.5, color: "#94a3b8" }}>
            لا توجد خيارات فرعية لهذا الصنف — يمكن إضافتها من الإعدادات ← زوار المكتب
          </div>
        )}

        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: "#475569", display: "block", marginBottom: 4 }}>📝 ملاحظات</label>
          <textarea style={{ ...inputStyle, minHeight: 80, resize: "vertical" }} value={notes}
            onChange={e => setNotes(e.target.value)} placeholder="ملاحظات على الزيارة..." />
        </div>

        {/* v3.3.920 — مرفقات الزيارة: واحد أو أكثر (PDF/صور/مستندات — حتى 25MB للملف) */}
        <div style={{ marginBottom: 16, background: "#f8fafc", border: "1px dashed #cbd5e1", borderRadius: 10, padding: 10 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: "#475569" }}>📎 مرفقات الزيارة <span style={{ fontWeight: 500, color: "#94a3b8" }}>(اختياري — ملف أو أكثر)</span></label>
            <label style={{ background: "#eff6ff", border: "1px solid #bfdbfe", color: "#1d4ed8", borderRadius: 8, padding: "5px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
              + إضافة ملفات
              <input type="file" multiple accept=".pdf,image/*,.doc,.docx,.xls,.xlsx" style={{ display: "none" }}
                onChange={e => { const fs2 = Array.from(e.target.files || []); e.target.value = ""; setNewFiles(p => [...p, ...fs2]); }} />
            </label>
          </div>
          {savedFiles.length === 0 && newFiles.length === 0 && <div style={{ fontSize: 11.5, color: "#94a3b8" }}>لا مرفقات — اضغط «إضافة ملفات» لإرفاق مستند أو أكثر (PDF، صور، Word، Excel).</div>}
          {savedFiles.map(f => (
            <div key={"s" + f.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "5px 6px", borderBottom: "1px solid #f1f5f9", fontSize: 12 }}>
              <a href={officeVisitors.fileUrl(initial.id, f.id)} target="_blank" rel="noopener noreferrer" style={{ flex: 1, color: "#1d4ed8", fontWeight: 600, textDecoration: "none", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>📄 {f.file_name}</a>
              <span style={{ color: "#94a3b8", fontSize: 11 }}>{fmtSize(f.size_bytes)}</span>
              <button type="button" onClick={async () => { if (!window.confirm(`حذف المرفق «${f.file_name}»؟`)) return; try { await officeVisitors.deleteFile(initial.id, f.id); setSavedFiles(p => p.filter(x => x.id !== f.id)); } catch { alert("فشل الحذف"); } }}
                style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 13 }} title="حذف">🗑</button>
            </div>
          ))}
          {newFiles.map((f, i) => (
            <div key={"n" + i} style={{ display: "flex", alignItems: "center", gap: 8, padding: "5px 6px", borderBottom: "1px solid #f1f5f9", fontSize: 12, background: "#fffbeb" }}>
              <span style={{ flex: 1, fontWeight: 600, color: "#92400e", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>🆕 {f.name}</span>
              <span style={{ color: "#94a3b8", fontSize: 11 }}>{fmtSize(f.size)}</span>
              <button type="button" onClick={() => setNewFiles(p => p.filter((_, j) => j !== i))} style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 13 }} title="إزالة">✕</button>
            </div>
          ))}
          {newFiles.length > 0 && <div style={{ fontSize: 11, color: "#92400e", marginTop: 4 }}>تُرفع {newFiles.length} ملفات عند الحفظ.</div>}
        </div>

        {err && <div style={{ color: "#dc2626", fontSize: 12.5, marginBottom: 10, fontWeight: 600 }}>{err}</div>}

        <div style={{ display: "flex", gap: 10, justifyContent: "flex-start" }}>
          <button onClick={save} disabled={saving} style={btnStyle("#059669")}>
            {saving ? "جاري الحفظ..." : (initial ? "حفظ التعديلات" : "تسجيل الزائر")}
          </button>
          <button onClick={onClose} style={btnStyle("#f1f5f9", "#475569")}>إلغاء</button>
        </div>
      </div>
    </div>
  );
}

export default function OfficeVisitorsPage() {
  const [visitors, setVisitors]   = useState([]);
  const [types, setTypes]         = useState([]);
  const [loading, setLoading]     = useState(true);
  const [q, setQ]                 = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [fromDate, setFromDate]   = useState("");
  const [toDate, setToDate]       = useState("");
  const [showForm, setShowForm]   = useState(false);
  const [editing, setEditing]     = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (q.trim()) params.q = q.trim();
      if (typeFilter) params.type_id = typeFilter;
      if (fromDate) params.from = fromDate;
      if (toDate) params.to = toDate;
      const [vRes, tRes] = await Promise.all([
        officeVisitors.list(params),
        officeVisitors.getTypes(),
      ]);
      setVisitors(vRes.data.visitors || []);
      setTypes(tRes.data.types || []);
    } catch { /* ignore */ }
    setLoading(false);
  }, [q, typeFilter, fromDate, toDate]);

  useEffect(() => { load(); }, [load]);

  const handleSave = async (data, files) => {
    let id = editing?.id;
    if (editing) await officeVisitors.update(editing.id, data);
    else { const r = await officeVisitors.create(data); id = r.data?.id; }
    // v3.3.920 — رفع المرفقات بعد حفظ الزيارة
    if (id && files && files.length) {
      try { await officeVisitors.uploadFiles(id, files); }
      catch (e) { alert("حُفظت الزيارة لكن فشل رفع المرفقات: " + (e.response?.data?.error || e.message)); }
    }
    await load();
  };

  const handleDelete = async (v) => {
    if (!window.confirm(`حذف الزائر «${v.name}»؟ (يُنقل لسلة المحذوفات)`)) return;
    try { await officeVisitors.delete(v.id); await load(); }
    catch { alert("فشل الحذف"); }
  };

  // طباعة الكشف الحالي (حسب الفلاتر المطبقة)
  const printReport = () => {
    const rowsHtml = visitors.map((v, i) => `
      <tr>
        <td>${i + 1}</td>
        <td>${v.name || ""}</td>
        <td style="direction:ltr">${v.phone || "—"}</td>
        <td>${v.type_name || "—"}</td>
        <td>${(Array.isArray(v.options) ? v.options : []).join("، ") || "—"}</td>
        <td>${v.notes || "—"}</td>
        <td>${fmtDate(v.visit_date)}</td>
        <td>${v.created_by_name || "—"}</td>
      </tr>`).join("");
    const w = window.open("", "_blank");
    w.document.write(`<!doctype html><html dir="rtl"><head><meta charset="utf-8">
      <title>كشف زوار المكتب</title>
      <style>
        body { font-family: 'Segoe UI', Tahoma, sans-serif; padding: 24px; color: #1e293b; }
        h1 { font-size: 20px; margin-bottom: 4px; }
        .sub { color: #64748b; font-size: 12px; margin-bottom: 16px; }
        table { width: 100%; border-collapse: collapse; font-size: 12px; }
        th { background: #059669; color: #fff; padding: 8px 10px; text-align: right; }
        td { border: 1px solid #e2e8f0; padding: 7px 10px; }
        tr:nth-child(even) td { background: #f8fafc; }
        @media print { body { padding: 8px; } }
      </style></head><body>
      <h1>🚪 كشف زوار المكتب</h1>
      <div class="sub">تاريخ الطباعة: ${new Date().toLocaleString("en-GB")} — عدد الزوار: ${visitors.length}</div>
      <table><thead><tr>
        <th>#</th><th>الاسم</th><th>الهاتف</th><th>الصنف</th><th>الخيارات</th><th>ملاحظات</th><th>تاريخ الزيارة</th><th>سجّله</th>
      </tr></thead><tbody>${rowsHtml}</tbody></table>
      <script>window.onload = () => window.print();<\/script>
      </body></html>`);
    w.document.close();
  };

  return (
    <div dir="rtl" style={{ padding: 20 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10, marginBottom: 16 }}>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>🚪 سجل زوار المكتب</h1>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>
            كشف بزوار المكتب حسب الصنف — إدارة الأصناف والخيارات من الإعدادات
          </div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={printReport} style={btnStyle("#0891b2")}><FiPrinter size={14} /> طباعة الكشف</button>
          <button onClick={() => { setEditing(null); setShowForm(true); }} style={btnStyle("#059669")}><FiPlus size={14} /> تسجيل زائر</button>
        </div>
      </div>

      {/* شريط الفلاتر */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginBottom: 14,
        background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, padding: 12 }}>
        <div style={{ position: "relative", flex: "1 1 200px", maxWidth: 280 }}>
          <FiSearch size={14} style={{ position: "absolute", right: 10, top: 11, color: "#94a3b8" }} />
          <input style={{ ...inputStyle, paddingRight: 32 }} value={q} onChange={e => setQ(e.target.value)} placeholder="بحث بالاسم / الهاتف / الملاحظات..." />
        </div>
        <select style={{ ...inputStyle, width: 170 }} value={typeFilter} onChange={e => setTypeFilter(e.target.value)}>
          <option value="">كل الأصناف</option>
          {types.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
        <label style={{ fontSize: 12, color: "#64748b" }}>من</label>
        <input type="date" style={{ ...inputStyle, width: 150 }} value={fromDate} onChange={e => setFromDate(e.target.value)} />
        <label style={{ fontSize: 12, color: "#64748b" }}>إلى</label>
        <input type="date" style={{ ...inputStyle, width: 150 }} value={toDate} onChange={e => setToDate(e.target.value)} />
        <button onClick={load} style={btnStyle("#f1f5f9", "#475569")}><FiRefreshCw size={13} /> تحديث</button>
        <span style={{ fontSize: 12, color: "#64748b", marginRight: "auto" }}>{visitors.length} زائر</span>
      </div>

      {/* الجدول */}
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, overflow: "hidden" }}>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ background: "#f1f5f9" }}>
                {["#", "الاسم", "الهاتف", "الصنف", "الخيارات", "ملاحظات", "📎", "تاريخ الزيارة", "سجّله", "إجراءات"].map(h => (
                  <th key={h} style={{ padding: "10px 12px", textAlign: "right", fontSize: 12, fontWeight: 700, color: "#475569", whiteSpace: "nowrap" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={10} style={{ padding: 30, textAlign: "center", color: "#94a3b8" }}>جاري التحميل...</td></tr>
              ) : visitors.length === 0 ? (
                <tr><td colSpan={10} style={{ padding: 30, textAlign: "center", color: "#94a3b8" }}>لا يوجد زوار مسجلون — اضغط "تسجيل زائر" للبدء</td></tr>
              ) : visitors.map((v, i) => (
                <tr key={v.id} style={{ borderTop: "1px solid #f1f5f9" }}>
                  <td style={{ padding: "9px 12px", color: "#94a3b8", fontSize: 12 }}>{i + 1}</td>
                  <td style={{ padding: "9px 12px", fontWeight: 600, color: "#1e293b" }}>{v.name}</td>
                  <td style={{ padding: "9px 12px", direction: "ltr", textAlign: "right", color: "#475569" }}>{v.phone || "—"}</td>
                  <td style={{ padding: "9px 12px" }}>
                    {v.type_name ? (
                      <span style={{ background: `${typeColor(v.type_name)}15`, color: typeColor(v.type_name),
                        border: `1px solid ${typeColor(v.type_name)}40`, padding: "3px 10px", borderRadius: 14, fontSize: 11.5, fontWeight: 700, whiteSpace: "nowrap" }}>
                        {v.type_name}
                      </span>
                    ) : "—"}
                  </td>
                  <td style={{ padding: "9px 12px", maxWidth: 220 }}>
                    {(Array.isArray(v.options) ? v.options : []).length
                      ? (v.options).map(o => (
                          <span key={o} style={{ display: "inline-block", background: "#f1f5f9", color: "#475569",
                            padding: "2px 8px", borderRadius: 10, fontSize: 11, margin: "1px 0 1px 4px" }}>{o}</span>
                        ))
                      : <span style={{ color: "#cbd5e1" }}>—</span>}
                  </td>
                  <td style={{ padding: "9px 12px", fontSize: 12, color: "#64748b", maxWidth: 240, whiteSpace: "pre-wrap" }}>{v.notes || "—"}</td>
                  <td style={{ padding: "9px 12px", fontSize: 12, whiteSpace: "nowrap" }}>
                    {(Array.isArray(v.files) ? v.files : []).length
                      ? <span style={{ display: "inline-flex", flexDirection: "column", gap: 2 }}>
                          {v.files.map(f => <a key={f.id} href={officeVisitors.fileUrl(v.id, f.id)} target="_blank" rel="noopener noreferrer" title={f.file_name} style={{ color: "#1d4ed8", fontWeight: 600, textDecoration: "none", fontSize: 11.5, maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis" }}>📎 {f.file_name}</a>)}
                        </span>
                      : <span style={{ color: "#cbd5e1" }}>—</span>}
                  </td>
                  <td style={{ padding: "9px 12px", fontSize: 12, color: "#475569", whiteSpace: "nowrap" }}>{fmtDate(v.visit_date)}</td>
                  <td style={{ padding: "9px 12px", fontSize: 12, color: "#64748b", whiteSpace: "nowrap" }}>{v.created_by_name || "—"}</td>
                  <td style={{ padding: "9px 12px", whiteSpace: "nowrap" }}>
                    <button onClick={() => { setEditing(v); setShowForm(true); }} title="تعديل"
                      style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 6, padding: "5px 8px", cursor: "pointer", color: "#2563eb", marginLeft: 6 }}>
                      <FiEdit2 size={13} />
                    </button>
                    <button onClick={() => handleDelete(v)} title="حذف"
                      style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 6, padding: "5px 8px", cursor: "pointer", color: "#dc2626" }}>
                      <FiTrash2 size={13} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showForm && (
        <VisitorForm types={types} initial={editing}
          onSave={handleSave} onClose={() => { setShowForm(false); setEditing(null); }} />
      )}
    </div>
  );
}
